<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>福利中心设置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="box-card">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
               <!-- <el-tab-pane label="福利中心" name="first">
                   <welfare></welfare>
               </el-tab-pane>
               <el-tab-pane label="幸运大转盘" name="second">
                    <turntable></turntable>
                </el-tab-pane> -->
                <el-tab-pane label="每日阅读" name="third">
                    <read></read>
                </el-tab-pane>
                <el-tab-pane label="签到设置" name="fourth">
                    <signIn></signIn>
                </el-tab-pane>
                 <el-tab-pane label="新手任务" name="novice">
                    <novice></novice>
                </el-tab-pane>
                 <el-tab-pane label="基础任务" name="basic">
                    <basic></basic>
                </el-tab-pane>
                 <el-tab-pane label="日常任务" name="daily">
                    <daily></daily>
                 </el-tab-pane> 
                <el-tab-pane label="运营活动" name="activity">
                    <activity></activity>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>

<script>
    import welfare from '../../components/system_welfare/welfare' //福利中心设置
    import turntable from '../../components/system_welfare/turntable' //幸运大转盘
    import read from '../../components/system_welfare/read'//每日阅读
    import signIn from '../../components/system_welfare/sign_in'//签到设置
    import invite from '../../components/system_welfare/invite'//签到设置
    import novice from '../../components/system_welfare/novice'//新手任务
    import basic from '../../components/system_welfare/basic'//基础任务
    import daily from '../../components/system_welfare/daily'//日常任务
    import activity from '../../components/system_welfare/activity' //运营活动
    import withdrawset from '../../components/system_welfare/withdraw_set'//签到设置
    export default {
        name: "Syatem_Fuli",
        components: {welfare, turntable, read, signIn,invite,novice,basic,daily,activity,withdrawset},
        data() {
            return {
                activeName: 'third'
            }
        },
        methods: {
            handleClick(tab, event) {
                //console.log(tab, event);
            }
        }
    }
</script>

<style scoped>

</style>